import React from 'react'

interface IconProps {
  className?: string
}

const Gantt05 = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5 10C5 9.44772 5.44772 9 6 9H14C14.5523 9 15 9.44772 15 10V14C15 14.5523 14.5523 15 14 15H6C5.44772 15 5 14.5523 5 14V10Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M10 16C10 15.4477 10.4477 15 11 15H21C21.5523 15 22 15.4477 22 16V20C22 20.5523 21.5523 21 21 21H11C10.4477 21 10 20.5523 10 20V16Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M2 4C2 3.44772 2.44772 3 3 3H8C8.55228 3 9 3.44772 9 4V8C9 8.55228 8.55228 9 8 9H3C2.44772 9 2 8.55228 2 8V4Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
)

export default Gantt05
